export default class ClearNotificationTimer {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.scheduler.cancel(id);
  }
}
